import { IconChatUIAlert } from 'components/Icons';
import styled from 'styled-components';

export const AnimationTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledErrorContainer = styled.div``;

export const StyledAlertIcon = styled(IconChatUIAlert)`
  width: ${({ theme }) => theme.spacing['9Xl']};
  height: ${({ theme }) => theme.spacing['9Xl']};
`;
export const StyledErrorWrapper = styled.div`
  width: 100%;
  height: ${({ theme }) => theme._ui.chatPanel.heightMainContent};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing.xl};
  span {
    padding: ${({ theme }) => `0 ${theme.spacing.xl}`};
  }
`;
